import React, { useState } from "react";
import { makeStyles, Grid, Paper, Box, OutlinedInput } from "@material-ui/core";
import NtkButton from "../../services/common/NtkButton";
const useStyles = makeStyles((theme) => ({
  root: {
    margin: "3.125rem 0",
  },
  commentInput: {
    width: "100%",
    height: "50px",
    [theme.breakpoints.down("md")]: {
      height: "75px",
    },
  },
  inputContainer: {
    display: "flex",
    justifyContent: "center",
    padding: 30,
  },
  grid: {
    [theme.breakpoints.down("md")]: {
      display: "block",
      padding: 10,
    },
  },
}));

const CommentInputField = ({ blogId }) => {
  const classes = useStyles();
  const [commentInput, setCommentInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const comment = JSON.stringify({
      content: commentInput.value,
    });
    const POST_URL = `https://natakallam.com/wp-json/wp/v2/comments?post=${blogId}`;
    fetch(POST_URL, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: comment,
    })
      .then((resp) => {
        if (resp.ok === true) {
          alert("Your comment posted.");
          setCommentInput("");
        }
        return resp.json();
      })
      .then((obj) => alert(`Error: ${obj.message}`))
      .catch((error) => console.error(error));
  };

  return (
    <Paper elevation={8} className={classes.root}>
      <form onSubmit={handleSubmit} className={classes.inputContainer}>
        <Grid spacing={2} container className={classes.grid}>
          <Grid item lg={10}>
            <OutlinedInput
              fullWidth
              onChange={(e) => setCommentInput(e.target.value)}
              required
              className={classes.commentInput}
              id="comment"
              placeholder="Write your comment..."
              variant="outlined"
            />
          </Grid>
          <Grid item lg={2}>
            <Box>
              <NtkButton type="submit" title="Submit" />
            </Box>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default CommentInputField;
